import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { SelectReact } from 'common/components/select';
import { DATE_FORMAT } from 'iron/apps/experiments/src/components/utils';
import { useExperimentPageContext } from 'iron/apps/experiments/src/components/context';
import { useUpdateExperiment } from 'iron/apps/experiments/src/components/hooks/update-experiment';
import { useLaunchExperiment } from 'iron/apps/experiments/src/components/hooks/launch-experiment';
import { ExperimentPageBannerDecideModal } from './_decide-modal';
const enum Actions {
  END_ANALYSIS = "end-analysis",
  RESTART_ANALYSIS = "restart-analysis",
}
export function ExposuresMakeDecision(props: React.ComponentProps<typeof SelectReact>) {
  const i18n = useTranslation();
  const {
    canEdit
  } = useExperimentPageContext();
  const updateExperiment = useUpdateExperiment();
  const launchExperiment = useLaunchExperiment();
  const [makingDecision, setMakingDecision] = React.useState(false);
  const onAction = async (action: Actions) => {
    if (action === Actions.END_ANALYSIS) {
      setMakingDecision(true);
    } else if (action === Actions.RESTART_ANALYSIS) {
      await updateExperiment({
        start_date: moment().format(DATE_FORMAT),
        end_date: null,
        exposures_cache: {},
        results_cache: {}
      });
      launchExperiment();
    }
  };
  return <>
      <SelectReact {...props} disableSearch disabled={!canEdit} menuWidth={260} sections={[{
      items: [{
        key: "end",
        label: i18n.t("experiments.banner.common.exposures-make-decision.cta-end"),
        wrapSubLabel: true,
        subLabel: i18n.t("experiments.banner.common.exposures-make-decision.cta-end-info"),
        value: Actions.END_ANALYSIS
      }]
    }, {
      items: [{
        key: "restart",
        label: i18n.t("experiments.banner.common.exposures-make-decision.cta-restart"),
        wrapSubLabel: true,
        subLabel: i18n.t("experiments.banner.common.exposures-make-decision.cta-restart-info"),
        value: Actions.RESTART_ANALYSIS
      }]
    }]} onChange={(ev: TODO) => onAction(ev.detail.item.value as Actions)} data-sentry-element="SelectReact" data-sentry-source-file="_exposures-make-decision.tsx" />
      {makingDecision && <ExperimentPageBannerDecideModal onClose={() => setMakingDecision(false)} />}
    </>;
}